import moment from "moment";

/**
 * Проверяет, является ли значение простым объектом (не массивом, не моментом и т.д.)
 */
function isPlainObject(value: unknown): value is Record<string, unknown> {
  return (
    typeof value === "object" &&
    value !== null &&
    !Array.isArray(value) &&
    !moment.isMoment(value)
  );
}

/**
 * Удаляет поля со значением undefined, не трогая объекты moment
 */
export function filterUndefinedFieldsDeep<T extends Record<string, unknown>>(
  obj: T,
): Partial<T> {
  const result: Partial<T> = {};

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const value = obj[key];

      if (value === undefined) continue;

      if (isPlainObject(value)) {
        const nested = filterUndefinedFieldsDeep(value);
        if (Object.keys(nested).length > 0) {
          result[key] = nested as any;
        }
      } else {
        result[key] = value as any;
      }
    }
  }

  return result;
}
